// extracted by mini-css-extract-plugin
module.exports = {"hidden":"index_hidden__6e7YG","textEmphasis":"index_textEmphasis__IwooG","wrapper":"index_wrapper__5yk78","passReviewArea":"index_passReviewArea__yQW2y"};